'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_display_Text_Text = require('../../display/Text/Text.cjs.js');
const components_navigation_InteractiveTag_InteractiveTagContext = require('./InteractiveTagContext.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_1co9n_1";
const styles = {
	root: root
};

const InteractiveTagContent = ({ body, title }) => {
  const contentRef = React.useRef(null);
  const { setBody, setIsTruncated, setTitle } = components_navigation_InteractiveTag_InteractiveTagContext.useInteractiveTagContext();
  const checkIsTruncated = () => {
    if (contentRef.current) {
      return contentRef.current.scrollWidth > contentRef.current.clientWidth;
    }
    return false;
  };
  React.useEffect(() => {
    setIsTruncated(checkIsTruncated());
    setBody(body);
    setTitle(title);
  }, []);
  return React__default.default.createElement(
    "div",
    { className: styles.root, ref: contentRef, "data-zds": true },
    React__default.default.createElement(
      components_display_Text_Text.Text,
      { color: "inherit", type: "Body3" },
      title,
      body ? ": " : ""
    ),
    body && React__default.default.createElement(components_display_Text_Text.Text, { color: "inherit", type: "Body1" }, body)
  );
};

exports.InteractiveTagContent = InteractiveTagContent;
//# sourceMappingURL=InteractiveTagContent.cjs.js.map
